// import logo from "../assets/wide_logo.png";
//import logo from "../assets/logo1.png";
//import logo from "../assets/square_logo.png";
import logo from "../assets/square_logo.png";
import widelogo from "../assets/wide_logo-trans.png";
import doublewidelogo from "../assets/double_wide_logo.png";
import placeholder from "../assets/placeholder.webp";

export function Logo() {
  return (
    <div className="logo">
      <img className="logo_png" src={logo} alt="logo"></img>
    </div>
  );
}

export function LogoMobile() {
  return (
    <div className="logo">
      <img
        className="logo_png_mobile top_buffer_15"
        src={logo}
        alt="logo"
      ></img>
    </div>
  );
}

export function DoubleWideLogo() {
  return (
    <div className="logo">
      <img
        className="double_wide_logo_png"
        src={doublewidelogo}
        alt="logo"
      ></img>
    </div>
  );
}

export function WideLogo() {
  return (
    <div className="logo">
      <img className="wide_logo_png" src={widelogo} alt="logo"></img>
    </div>
  );
}

export function Placeholder() {
  return (
    <div className="logo">
      <img className="placeholder" src={placeholder} alt="placeholder"></img>
    </div>
  );
}
